export default __webpack_public_path__ + "static/media/geo-alt.aa0c8e24.svg";